module.exports = __webpack_public_path__ + "img/pencile.dd7446c9.svg";